import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, Injector, inject, ChangeDetectionStrategy } from '@angular/core';
import { Utypi03Component } from './utypi03Pkg.component';
import { Utypi03DetailComponent } from './utypi03-detailPkg.component';
import { JackBaseComponentModule,MaterialModule } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';

@Component({
  selector: 'app-utypi03-bill',
  standalone: true,
  imports: [CommonModule,
    MaterialModule,
    JackBaseComponentModule,
    Utypi03Component,
    Utypi03DetailComponent,
    ],
  templateUrl: './utypi03BillPkg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Utypi03BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = ' utypi03'; //###
  override masterPage!:  Utypi03Component;
  override detailPage!:  Utypi03DetailComponent;
  constructor() {
    //const injector = inject(Injector);

    super();
    this.setFormOpt2(); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------


}
